import { supabase } from './supabase';

export const getPolicies = () =>
  supabase.from('policies').select('*').order('section_number');

export const getPolicy = (sectionNumber) =>
  supabase.from('policies').select('*').eq('section_number', sectionNumber).single();

export const getPolicyRevisions = (policyId) =>
  supabase.from('policy_revisions').select('*, changed_by:profiles(full_name)').eq('policy_id', policyId).order('changed_at', { ascending: false });

export const getSops = () =>
  supabase.from('sops').select('*').order('code');

export const getForms = () =>
  supabase.from('forms').select('*').order('title');

export const getReferenceMaterials = () =>
  supabase.from('reference_materials').select('*').order('title');

export const getLinkedItems = async (policyId) => {
  const [sops, forms, refs] = await Promise.all([
    supabase.from('sops').select('id, code, title').eq('linked_policy_id', policyId),
    supabase.from('forms').select('id, title, category').eq('linked_policy_id', policyId),
    supabase.from('reference_materials').select('id, title, source').eq('linked_policy_id', policyId),
  ]);
  return {
    sops: sops.data || [],
    forms: forms.data || [],
    referenceMaterials: refs.data || [],
  };
};

// Acknowledgment %: staff with an active login are the addressable audience today
// (policy sign-off flows through the app UI). Field staff without logins ack via
// the Part 2 no-login training link when a training module links to this policy.
export const getPolicyAcknowledgmentStats = async (sectionNumber, version) => {
  const [{ count: totalStaff }, { data: acks }] = await Promise.all([
    supabase.from('staff').select('id', { count: 'exact', head: true }).eq('status', 'active'),
    supabase.from('document_acknowledgments')
      .select('staff_id, staff:staff(full_name)')
      .eq('document_type', 'policy')
      .eq('version_acknowledged', version)
  ]);
  const total = totalStaff || 0;
  const acknowledged = (acks || []).length;
  return { total, acknowledged, pct: total ? Math.round((acknowledged / total) * 100) : 0, acks: acks || [] };
};

export const acknowledgePolicy = (policyId, version, staffId, signatureRef) =>
  supabase.from('document_acknowledgments').insert([{
    document_type: 'policy', document_id: policyId, version_acknowledged: version,
    staff_id: staffId, signature_ref: signatureRef,
  }]);
